<template>
  <ReadingFollowup
    v-if="prompt?.kind === FLUID_PROMPT_KIND.READING"
    v-model:open="open"
    :reading="prompt.context"
  />
  <template v-else-if="prompt">
    <ReadingFollowup
      v-if="
        code === FLUID_NOTIFICATION.OVERDUE &&
        prompt.context.dashboard.alert &&
        !prompt.context.dashboard.alert.dismissed
      "
      v-model:open="open"
      :reading="prompt.context"
    />
    <AttendanceDialog
      v-else-if="code === FLUID_NOTIFICATION.ATTENDANCE || code === FLUID_NOTIFICATION.OVERDUE"
      v-model:open="open"
      :gap="code === FLUID_NOTIFICATION.OVERDUE"
      :context="prompt.context"
      :notification-unique="prompt.data?.itemUnique"
    />
    <ReadingReminderDialog
      v-else-if="code === FLUID_NOTIFICATION.READING || code === FLUID_NOTIFICATION.FOLLOWUP"
      v-model:open="open"
      :followup="code === FLUID_NOTIFICATION.FOLLOWUP"
      :time="time"
      :type="prompt.context.reminder.type"
    />
    <DryWeightUpdateDialog
      v-else-if="code === FLUID_NOTIFICATION.DRY_WEIGHT"
      v-model:open="open"
      :update="prompt.context.dryWeightUpdate"
    />
    <ReadingFollowup v-else v-model:open="open" :reading="prompt.context" />
  </template>
</template>
<script setup>
// 1. Import necessary components
import { computed } from 'vue';
import DateUtils from '@/shared/utilities/date-utils';
import { FLUID_NOTIFICATION, FLUID_PROMPT_KIND } from '../constants/notification';
import { useFluidStore } from '@/core/stores/fluid.store';
import ReadingFollowup from './ReadingFollowup.vue';
import AttendanceDialog from './AttendanceDialog.vue';
import ReadingReminderDialog from './ReadingReminderDialog.vue';
import DryWeightUpdateDialog from './DryWeightUpdateDialog.vue';

// 2. Use
const fluid = useFluidStore();

// 3. Define a reactive variable

// 4. Define methods or computed properties if needed
// One presenter selects the active clinical dialog, regardless of its trigger.
const prompt = computed(() => fluid.prompt);
const open = computed({
  get: () => Boolean(fluid.prompt),
  set: (value) => {
    if (!value) {
      fluid.closePrompt();
    }
  },
});
const code = computed(() => prompt.value?.context.notificationCode);
const time = computed(() => {
  if (!prompt.value?.data?.scheduledAtUtc) {
    return '';
  }
  return DateUtils.formatDateTime(
    new Date(prompt.value.data.scheduledAtUtc.replace(' ', 'T') + 'Z'),
    'HH:mm',
  );
});

// 5. VueJS Hooks
</script>
